import { CodeBook } from "@king-ict/eupisi-ui/models/Common/CodeBook";
import { getI18n } from "react-i18next";

export const getEnumToCodeBook = <TEnum extends {}>(type: TEnum, enumName: string): CodeBook[] => {
    const i18 = getI18n();
    const arrayObjects = [] as CodeBook[];
    for (const [propertyKey, propertyValue] of Object.entries(type)) {
        var num = Number.parseInt(propertyKey);
        if (isNaN(num)) {  
            continue;
        }
        var transKey = enumName + "." + propertyValue;
        var trans = i18.t(transKey);
        var codeBook = { id: num, name: trans } as CodeBook;
        arrayObjects.push(codeBook);  
    }
    return arrayObjects.sort((a,b) => a.id - b.id);
  };